import {Component, Inject, OnInit, PLATFORM_ID} from '@angular/core';
import {PddService} from '../../services/pdd.service';
import {isPlatformBrowser, NgFor} from '@angular/common';
import {Router, NavigationEnd, RouterLink} from '@angular/router';
import {ZnakiService} from '../../services/znaki.service';
import {RazmetkaService} from '../../services/razmetka.service';
import {BilletsService} from '../../services/billets.service';
import {Title, Meta} from '@angular/platform-browser';
import {filter} from 'rxjs';
import {SettingsComponent} from '../../components/settings/settings.component';
import {SettingsService} from '../../services/settings.service';

@Component({
  selector: 'home-page',
  templateUrl: './home.component.html',
  imports: [NgFor, RouterLink, SettingsComponent],
  styleUrl: './home.component.less'
})
export class HomePageComponent {
  constructor(@Inject(PLATFORM_ID) private platformId: Object, private router: Router, public BilletsService:BilletsService, public PddService: PddService, public ZnakiService: ZnakiService, public RazmetkaService: RazmetkaService, private title: Title, private meta: Meta, public SettingsService: SettingsService) {
    this.router.events
      .pipe(filter(event => event instanceof NavigationEnd))
      .subscribe(() => {
        if (isPlatformBrowser(this.platformId)) {
          this.SettingsService.set_open_settings(false)
          window.scrollTo({
            top: 0,
            behavior: 'smooth' // или убери behavior для мгновенного скролла
          });
        }
      });
  }

  ngOnInit(): void {
    this.title.setTitle('ПДД');

    this.meta.updateTag({
      name: 'description',
      content: 'ПДД — бесплатная подготовка к экзамену ГИБДД 2026. Билеты ПДД, дорожные знаки, правила дорожного движения, разбор ошибок, экзаменационные вопросы и обучение онлайн.'
    });

    this.meta.updateTag({
      name: 'keywords',
      content: 'ПДД 2026, билеты ПДД, экзамен ГИБДД, теория ПДД, дорожные знаки, правила дорожного движения, ПДД онлайн, подготовка к экзамену ГИБДД, билеты ГИБДД, обучение ПДД, тест ПДД, ПДД, pddbox'
    });
  }

}
